import { AiFillWarning } from 'react-icons/ai';
import classNames from 'classnames';

type Props = {
  message?: string;
  className?: string;
  icon?: boolean | JSX.Element;
  size?: 'small' | 'medium' | 'large';
  children?: JSX.Element;
  severity?: 'error' | 'warning' | 'info' | 'secondary';
};

const Alert = ({
  message,
  className,
  children,
  severity = 'info',
  icon = false,
  size = 'large',
}: Props) => {
  const alertClassName = classNames('flex gap-4 rounded-md shadow-md', className, {
    'bg-yellow-50 text-yellow-600': severity === 'warning',
    'bg-red-100 text-red-800': severity === 'error',
    'bg-green-50': severity === 'info',
    'bg-gray-50': severity === 'secondary',
    'items-center': message,
    'px-7 py-4': size === 'large',
    'p-3': size === 'medium',
    'p-2': size === 'small',
  });

  const renderIcon = () => {
    if (severity === 'warning' || severity === 'error' || icon) {
      return typeof icon === 'boolean' ? (
        <AiFillWarning
          size={size === 'small' ? 20 : 25}
          className={classNames('shrink-0', {
            'text-yellow-400': severity === 'warning',
            'text-red-700': severity === 'error',
          })}
        />
      ) : (
        icon
      );
    }

    return null;
  };

  return (
    <div className={alertClassName} role="alert">
      {renderIcon()}
      {children || (message ? <p>{message}</p> : null)}
    </div>
  );
};

export default Alert;
